import Vue, { RenderContext } from 'vue';
import { mergeData } from 'vue-functional-data-merge';

export const props = {
    cols: {
        type: [Number, String],
        default: null
    },
    sm: {
        type: [Number, String],
        default: null
    },
    md: {
        type: [Number, String],
        default: null
    },
    lg: {
        type: [Number, String],
        default: null
    },
    xl: {
        type: [Number, String],
        default: null
    }
};

const getColClass = (props: any) => {
    const classes: string[] = [];
    for (const prop in props) {
        const bp = prop;
        const val = props[bp];
        if (!bp || !val) continue;

        if (bp === 'cols') {
            const _class = `col-${val}`;
            classes.push(_class);
        } else {
            const _class = `col-${bp}-${val}`;
            classes.push(_class);
        }
    }

    return classes;
};

export const TCol = Vue.extend({
    name: 'TCol',
    functional: true,
    props,
    render(h: any, { props, children, data }: RenderContext) {
        return h(
            'div',
            mergeData(data, {
                class: ['col', ...getColClass(props)]
            }),
            children
        );
    }
});
